import { render, staticRenderFns } from "./student-able.vue?vue&type=template&id=6260205f&"
import script from "./student-able.vue?vue&type=script&lang=ts&"
export * from "./student-able.vue?vue&type=script&lang=ts&"
import style0 from "./student-able.vue?vue&type=style&index=0&id=6260205f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports